// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import UserAvatar from '@Atoms/UserAvatar/UserAvatar';
import { UserOutput } from 'thehive-sdk';
import { FormatDate } from '@Molecules/Format';
import { useLocalMessage } from '@Helpers/locale';
import { PreviewButton } from '@Atoms/Buttons';

import './GlobalUserDetails.scss';

interface GlobalUserDetailsProps {
    data: UserOutput;
    onPreviewClick: () => void;
}

export const GlobalUserDetails = ({ data, onPreviewClick }: GlobalUserDetailsProps): ReactElement => {
    const i = useLocalMessage();
    const lockedUntil = data.extraData?.lockout?.lockedUntil;
    return (
        <div className="global-user-details">
            <UserAvatar name={data.name} avatar={data.avatar} size="large" />
            <div className="global-user-details__info">
                <span>{data.name}</span>
                <span className="global-user-details__info__login">{data.login}</span>
                {lockedUntil ? (
                    <span className="global-user-details__info-locked">
                        {i('user.list.table.description.lockedUntil')} <FormatDate date={lockedUntil} />
                    </span>
                ) : null}
            </div>

            <div className="generic-drawer-preview">
                <PreviewButton onClick={onPreviewClick} />
            </div>
        </div>
    );
};
